<template>
  <div class="staff-commission big">

    <div class="flex between"
         style="padding-right:20px">
      <div class="page_title">提成管理</div>
    </div>

    <div style="padding:20px;">
      <div class="container">

        <div class="staff-commission-header">
          <el-card v-for="(item,index) in totalAmount"
                   :key="index"
                   class="box-card">
            <p>{{ item.label }}</p>
            <p>￥{{ numFormat(item.value) }}</p>
          </el-card>
        </div>

        <div class="staff-commission-body">
          <el-tabs v-model="activeName"
                   @tab-click="handleClick">
            <el-tab-pane label="按月按员工"
                         name="1"
                         lazy></el-tab-pane>
            <el-tab-pane label="按员工"
                         name="2"
                         lazy></el-tab-pane>
            <el-tab-pane label="按月"
                         name="3"
                         lazy></el-tab-pane>
          </el-tabs>
          <component :is="currentComponent"
                     @getInfo="getInfo" />
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import MonthAndStaff from './components/MonthAndStaff.vue';
import AccordingStaff from './components/AccordingStaff.vue';
import AccordingMonth from './components/AccordingMonth.vue';

export default {
  components: {},
  data() {
    return {
      totalAmount: [],
      activeName: '1'
    };
  },
  computed: {
    currentComponent() {
      if (
        this.activeName == '1' &&
        (this.module_id_array.includes('640') || this.module_id_array == '')
      ) {
        return MonthAndStaff;
      } else if (
        this.activeName == '2' &&
        (this.module_id_array.includes('647') || this.module_id_array == '')
      ) {
        return AccordingStaff;
      } else if (
        this.activeName == '3' &&
        (this.module_id_array.includes('646') || this.module_id_array == '')
      ) {
        return AccordingMonth;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    }
  },
  created() {},
  methods: {
    getInfo(data) {
      // staff.getProportionManageList();
      this.totalAmount = [
        { label: '未扎账金额', value: data.total_transaction_money },
        { label: '不可提总额', value: data.total_no_get_money },
        { label: '已可提总额', value: data.total_get_money },
        { label: '待审批总额', value: data.total_ready_money },
        { label: '已提成总额', value: data.total_money }
      ];
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    numFormat(num) {
      var c =
        num.toString().indexOf('.') !== -1
          ? num.toLocaleString()
          : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      return c;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
.staff-commission {
  .staff-commission-header {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .box-card {
      width: 15%;
      height: 100px;
      background-color: #f2f2f2;
      ::v-deep .el-card__body {
        padding: 0;
        display: flex !important;
        flex-direction: column;
        justify-content: space-around;
        font-size: 20px;
        font-weight: bold;
        height: 100%;
        p {
          margin: 0;
          height: 20px;
        }
      }
    }
  }
  .staff-commission-body {
    padding-top: 20px;
    ::v-deep .el-tabs__item {
      font-size: 16px;
    }
  }
}
</style>